import BillingsOrderForwardRelatedTaxiDriverRequest from "../../../../../api/raily/billings/order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver.request";
import BillingsOrderForwardRelatedTaxiDriverParams from "./billings-order-forward-related-taxi-driver-params";

const create = (
  params: BillingsOrderForwardRelatedTaxiDriverParams,
): BillingsOrderForwardRelatedTaxiDriverRequest => {
  return {
    forwardingId: params.forwardingUuid,
  };
};

const billingsOrderForwardRelatedTaxiDriverParamsFactory = {
  create,
};

export default billingsOrderForwardRelatedTaxiDriverParamsFactory;
